const trackImageErrors = (imageUrl) => {
	if (!imageUrl) return;
	
	// TrackJS.track("Failed to load image: " + imageUrl);
};

export default trackImageErrors;
